import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { copyTextToClipboard } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const PaymentDetailCopyPopup = ({ popupRef = null, ...props }) => {
    const { detailsCopyMessage } = usePageMessages();

    return (
        <SimplePopup text={props.info} popupRef={popupRef}>
            <PopupButton
                iconName="copy"
                text={props.paymentCopyButton}
                onClick={(e) => {
                    e.preventDefault();
                    copyTextToClipboard(props.copyDetails);
                    props.toggleSnackBar(true, `${detailsCopyMessage}`);
                }}
            />
        </SimplePopup>
    );
};

PaymentDetailCopyPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { toggleSnackBar })(PaymentDetailCopyPopup);
